<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="right"><em>This book is for Ellen and Mimi; and for Tom and Dona, wonderful in-laws and even better grandparents to my sons.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062028976_epub_ded_r1.vue?b8b41328